import React from 'react';
import { Play, Check } from 'lucide-react';
import { unq1, unq2 } from '../assets/assets';

const UniqueFeatures = () => {
  // Content data
  const features = [
    {
      id: 1,
      icon: <Check size={20} className="text-gray-200" />,
      title: "Tell us what you need",
      description: "Share your project requirements in a few simple steps. Whether it’s a website, app, or technical solution, we make it easy to explain exactly what you’re looking for."
    },

    {
      id: 2,
      icon: <Check size={20} className="text-gray-300" />,
      title: "Select from the available experts",
      description: "Browse through verified professionals with proven skills and experience. Compare profiles, reviews, and pricing to choose the perfect expert for your project."
    },
    {
      id: 3,
      icon: <Check size={20} className="text-[#174568]" />,
      title: "Get it done",
      description: "Collaborate seamlessly and track progress from start to finish. Our experts deliver high-quality results on time, so you can focus on what matters most."
    }
  ];

  return (
    <section className="bg-[#ACACAC1F] py-8 md:py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:flex-wrap">
          {/* Left side - Video/Images */}
          <div className="w-full md:w-1/2 md:pr-8 mb-6 md:mb-0">
            <div className="relative mb-3 md:mb-6 h-[322px]">
              <div className="rounded-xl md:rounded-2xl overflow-hidden h-full">
              <iframe
  className="w-full h-full"
  src="https://www.youtube.com/embed/ujPDRl1q-dw?autoplay=1&mute=0&loop=1&playlist=ujPDRl1q-dw"
  title="YouTube video player"
  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowFullScreen
></iframe>
              </div>
           
            </div>
            <div className="flex gap-3 md:gap-4">
              <div className="w-1/2 rounded-xl md:rounded-2xl overflow-hidden">
                <img 
                  src={unq1} 
                  alt="Developer working" 
                  className="w-full h-auto"
                />
              </div>
              <div className="w-1/2 rounded-xl md:rounded-2xl overflow-hidden">
                <img 
                  src={unq2}
                  alt="Modern workspace" 
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
          
          {/* Right side - Text content */}
          <div className="w-full md:w-1/2 md:pl-8">
            <h2 className="text-xl md:text-3xl font-bold text-[#174568] mb-4 md:mb-10">WHY WE ARE UNIQUE</h2>
            
            <div className="space-y-4 md:space-y-6">
              {features.map((feature, index) => (
                <div 
                  key={feature.id} 
                  className={`rounded-xl p-4 md:p-6 ${
                    index === 2 ? 'bg-[#174568]' : 'bg-gray-200 text-gray-800'
                  }`}
                >
                  <div className="flex items-start">
                    <div className={`rounded-full w-7 h-5 md:w-[20.66px] md:h-[20.66px] flex items-center justify-center mr-2 md:mr-3 ${
                      index === 2 ? 'bg-[#EDF2FE]' : 'bg-[#EDF2FE]'
                    }`}>
                      {React.cloneElement(feature.icon, { 
                        size: typeof window !== 'undefined' && window.innerWidth < 768 ? 16 : 20 
                      })}
                    </div>
                    <div>
                      <h3 className={`font-medium text-base md:text-lg mb-1 md:mb-2 ${index === 2 ? 'text-white' : 'text-[#174568]'}`}>{feature.title}</h3>
                      <p className={`text-xs md:text-sm ${index === 2 ? 'text-white' : 'text-black'}`}>{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniqueFeatures;